import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { PermisosValidarService } from '../services/Seguridad/permisos-validar.service';
import { permisosInterface } from '../Model/Seguridad/permisos.Interface';

@Injectable({
  providedIn: 'root'
})
export class PermisosValidateGuard implements CanActivateChild {
  public permisos: permisosInterface;
  constructor(public permisosValidar: PermisosValidarService) {

  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (state.url.substr(1) == 'dashboard') {
      return true;
    }
    this.permisos = this.permisosValidar.validateGuard(state.url);
    
    if(this.permisos == undefined){
      return true;
    }

    if (this.permisos.visible == false) {
      return false;
    }

    return true;

  }

}
